export type ColorScheme = {
    color: string;
    text: string;
}

export type ColorKey =
    | "blue"
    | "cyan"
    | "teal"
    | "green"
    | "yellow"
    | "orange"
    | "red"
    | "pink"
    | "purple"
    | "gray"
    | "indigo"
    | "violet"
    | "fuchsia"
    | "rose"
    | "emerald";
